import React, { useState, useEffect, useRef } from "react"
import { graphql } from "gatsby"
import Layout from "../../components/Layout/Layout"
import Seo from "gatsby-plugin-wpgraphql-seo"
import Content from "../../components/Content/Content"
import Headshot from "../../components/Headshot/Headshot"
import { Row, Col, Badge } from "react-bootstrap"
import { getImage } from "gatsby-plugin-image"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"
import SpotifyPlayer from "react-spotify-player"
import cleanString from "../../helpers/cleanString"

const TeamMember = ({ data }) => {
  const { page } = data
  const { title, TeamMembers } = page

  const [height, setHeight] = useState(0)
  const ref = useRef(null)

  useEffect(() => {
    setHeight(ref.current.clientHeight - 375)
  }, [height])

  const { conviction, spotifyEmbed, bio, image } = TeamMembers
  const headshot = image?.gatsbyImage ? getImage(image.gatsbyImage) : ""
  const fullName = title.split(" "),
    firstName = fullName[0],
    lastName = fullName[fullName.length - 1]

  return (
    <Layout bodyClass={title}>
      <Seo post={page} />
      <section className="container">
        <Row className="team-member">
          <Col xs={12} md={5}>
            <Headshot
              image={headshot}
              altText={image?.altText}
              height={height}
            />
          </Col>
          <Col
            className="team-member-info h-100 d-flex flex-column"
            xs={10}
            md={6}
            ref={ref}
          >
            <div className="team-member-head offset-md-1 py-3 py-md-0 w-100">
              <h1>
                {`${firstName} `}
                <br />
                {lastName}
              </h1>
              <Badge className="px-0 mb-4">{TeamMembers.title}</Badge>
              <Content
                className="mb-4"
                content={`${firstName}'s conviction: ${cleanString(
                  conviction
                )}`}
              />
              <a
                className="bio-anchor d-none d-md-inline-flex flex-column h6 align-items-center"
                href="#bio"
              >
                Learn more about {firstName}
                <FontAwesomeIcon
                  className="text-lead mt-2"
                  icon={faChevronDown}
                />
              </a>
              <a
                className="mobile-bio-anchor d-flex flex-column d-md-none h6 align-items-center no-wrap"
                href="#mobile-bio"
              >
                Learn more about {firstName}
                <FontAwesomeIcon
                  className="text-lead mt-3"
                  icon={faChevronDown}
                />
              </a>
            </div>
            <div id="bio" className="bio d-none d-md-block w-100">
              <Content content={bio} />
              <a
                href={`https://open.spotify.com/playlist/${spotifyEmbed}`}
                target="_blank"
                rel="noreferrer"
              >
                Check out {firstName}'s full playlist on spotify.
              </a>
            </div>
          </Col>
          <div id="mobile-bio">
            <Col
              xs={10}
              className="mobile-bio d-block d-md-none ml-auto mr-auto pl-3 pr-3 py-3"
            >
              <Content content={bio} />
              <a
                href={`https://open.spotify.com/playlist/${spotifyEmbed}`}
                target="_blank"
                rel="noreferrer"
              >
                Check out {firstName}'s full playlist on spotify.
              </a>
            </Col>
          </div>
        </Row>
      </section>
      <div className="spotify">
        <SpotifyPlayer
          uri={`spotify:playlist:${spotifyEmbed}`}
          size="compact"
          view="list"
          theme="black"
        />
      </div>
    </Layout>
  )
}

export const query = graphql`
  query teamMember($id: String!) {
    page: wpTeamMember(id: { eq: $id }) {
      ...TeamMemberFragment
    }
  }
`

export default TeamMember
